<!-- Login page content -->
<div id="loginContainer" class="container-fluid">
  <div id="loginRow" class="row">
    <div id="loginCol" class="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2 confirm-registration-form">
      <div id="loginCentralLogo" class="central_logo"> <img class="img-fluid" alt="IPOS Central LOGO" /> </div>
      <!-- Login Section -->
      <div id="loginCard" class="card cnfReg_card">
        <form [formGroup]="regForm" class="reg-container" (ngSubmit)="onConfirmRegistration()">
          <div id="loginFormHeader" class="form_header" [innerHTML]="heading"></div>
          <div id="loginEmail" class="" *ngIf="!email">
            <label class="control-label" for="confirmationCode">Email</label>
            <input id="email" type="email" maxlength="50" class="form-control" formControlName="email">
          </div>
          <div id="loginHelpBlock" class="help-block">
            <div id="confirmation_err" class="alert alert-success">
              <span class="text_color" i18n="@@confirm-registration.confirmation-code-msg">Thank you, {{firstName}}. Please enter the 
                confirmation code sent to <strong>{{emailNotification}}</strong> to activate your IPOS account.</span></div>
          </div>
          <label for="confirmationCode" [innerHTML]="code"></label>  
            <input [ngClass]="{ 'has-error': errorMessage  && isInVaildCode}"
            class="form-control" type="text" [placeholder]="placeholderConfirmationCode" formControlName="confirmationCode">
            <em class="err_icon" *ngIf="errorMessage && isInVaildCode"></em>
          <div id="loginErrMsg" *ngIf="errorMessage" [class]="alertFormat">
            {{ errorMessage }}
          </div>
          
          <div id="loginBtn" class="confm_btn">
            <button type="button" (click)="resendCode()" class="resend_code btn btn-outline-primary" [innerHTML]="resend"></button>
              <button type="submit" class="btn btn-primary" [disabled]="regForm.invalid" [innerHTML]="button"></button>
            

          </div>
        
          
        </form>
      </div>
      <iposcen-spinner-overlay></iposcen-spinner-overlay>
      
    </div>
  </div>
</div>